import TREditModal from './TREditModal'
export default TREditModal
